import { memo, useEffect, useState } from 'react';
import { useStore } from 'store/StoreContext';
import { UserRegister1Template } from 'components/templates/UserRegister1Template';
import { clearUserDataGenerator, initialRegisterUserData } from 'store/register-user/RegisterUserData';

type Props = {};

export const UserRegister1Page = memo((_props: Props) => {
	const [store, dispatch] = useStore(); // eslint-disable-line
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		const execute = async () => {
			clearUserDataGenerator(dispatch, initialRegisterUserData);
			setLoading(false);
		};
		execute();
	}, []);

	if (loading) {
		return null;
	}

	return <UserRegister1Template />;
});
